import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './MilestoneItem.m.sass';
import CompletionToggle from '../CompletionToggle';
var MilestoneItem = function MilestoneItem(_ref) {
  var milestone = _ref.milestone,
    isLast = _ref.isLast,
    state = _ref.state;
  var completedTasks = milestone.tasks.filter(function (x) {
    return x.completed;
  }).length;
  var totalTasks = milestone.tasks.length;
  var isSelected = milestone === state.milestone;
  return /*#__PURE__*/React.createElement("a", {
    className: cx(styles.root, _defineProperty(_defineProperty({}, styles.last, isLast), styles.selected, isSelected)),
    onClick: function onClick(e) {
      return state.selectMilestone(milestone);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.status
  }, /*#__PURE__*/React.createElement(CompletionToggle, {
    completed: milestone.completed,
    readOnly: true,
    size: 18,
    title: milestone.completed ? 'This milestone has been completed' : 'Not completed yet'
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title,
    title: milestone.title
  }, milestone.title, /*#__PURE__*/React.createElement("span", {
    className: styles.progress
  }, completedTasks, " of ", totalTasks, " tasks completed")), milestone.description && /*#__PURE__*/React.createElement("div", {
    className: styles.description,
    title: milestone.description
  }, milestone.description)));
};
export default observer(MilestoneItem);
//# sourceMappingURL=MilestoneItem.js.map
